export default {
  stepNotFound: 'Steg ikke funnet',
  noDescription: 'Ingen beskrivelse',
  expectedStartDate: 'Forventet startdato',
  batchName: 'Batchnavn',
  nextStep: 'Neste steg',
  noUpcomingSteps: 'Ingen kommende steg'
};
